export default "assets/images/logo_circle_dark-27235869.png";